<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Zone di Manutenzione Standard
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickAggiungiPunti" small v-bind="attrs" v-on="on">
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di chiusura del dialog -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChuidi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <!-- Tabella dei punti standard -->
      <v-data-table
        :headers="headers_punti_standard"
        :items="items_punti_standard"
      >
        <template v-slot:[`item.modifica`]="{ item }">
          <!-- Bottone di modifica -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickModificaPunto(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modifica</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.elimina`]="{ item }">
          <!-- Bottone di eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickEliminaPunto(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Dialog di modifica dei punti standard -->
    <v-dialog persistent v-model="dialog_modifica_punti" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Zona Standard
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaPunti" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogModificaPunti"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="punto_sel.des"></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di eliminazione dei punti standard -->
    <v-dialog persistent v-model="dialog_conferma_elimina_punti" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Eliminazione Zona Standard
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 18px">
            Confermi di voler eliminare questa Zona di Manutenzione Standard?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" align="center">
                <!-- Bottone di annullamento eliminazione -->
                <v-btn class="mr-5" @click="chiudiConfermaEliminaPunto" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <!-- Bottone di conferma eliminazione -->
                <v-btn @click="eliminaPunto" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay -->
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import EMStandardPoint from "@/classes/EMStandardPoint.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",
  components: {
    SnackbarQV,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      punto_sel: new EMStandardPoint(),

      // Modal
      caricamento_dati: false,
      dialog_conferma_elimina_punti: false,
      dialog_modifica_punti: false,

      // Array
      headers_punti_standard: [
        {
          text: "Modifica",
          sortable: false,
          value: "modifica",
          width: "150px",
        },
        {
          text: "Sede Standard",
          sortable: false,
          value: "des",
        },
        {
          text: "Elimina",
          sortable: false,
          value: "elimina",
          width: "150px",
        },
      ],
      items_punti_standard: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.getPuntiStandard();
        }
      },
    },
  },
  methods: {
    chiudiDialogModificaPunti() {
      this.dialog_modifica_punti = false;
      this.punto_sel = new EMStandardPoint();
    },
    chiudiConfermaEliminaPunto() {
      this.punto_sel = new EMStandardPoint();
      this.dialog_conferma_elimina_punti = false;
    },
    clickAggiungiPunti() {
      this.punto_sel = new EMStandardPoint();
      this.dialog_modifica_punti = true;
    },
    clickChuidi() {
      this.$emit("click_chiudi");
    },
    clickEliminaPunto(arg) {
      this.punto_sel = new EMStandardPoint(arg);
      this.dialog_conferma_elimina_punti = true;
    },
    clickModificaPunto(arg) {
      this.punto_sel = new EMStandardPoint(arg);
      this.dialog_modifica_punti = true;
    },
    eliminaPunto() {
      const obj_tmp = new EMStandardPoint(this.punto_sel);
      obj_tmp.validita = 0;

      const request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "settabella",
          token: localStorage.user_token,
          id_utente: localStorage.id,
          tabella: [obj_tmp],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Aggiorno i punti di manutenzione: in caso la prossima chiamata sia zoppa, il
             * dialog non si chiude ma se questa era ok almeno vedo i dati aggiornati. */
            this.getPuntiStandard();

            // Faccio una chiamata per allineare tutte le zone standard di tutte le barche
            const zona_tmp = res.data[0];
            zona_tmp.causale = "update";
            const setzonagenerica = {
              controller: "Manutenzione",
              method: "PUT",
              richiesta: {
                action: "setzonagenerica",
                token: localStorage.user_token,
                zona: [zona_tmp],
              },
            };

            this.$store
              .dispatch("api", setzonagenerica)
              .then((resp) => {
                if (resp.status === 200) {
                  this.punto_sel = new EMStandardPoint();
                  this.dialog_conferma_elimina_punti = false;

                  this.$refs.SnackbarQV.print(
                    "success",
                    "Zona di Manutenzione Standard eliminata con successo."
                  );
                } else {
                  this.$refs.SnackbarQV.print(
                    "orange",
                    "Errore di comunicazione col server."
                  );
                }
              })
              .catch((ex) => {
                if (ex) {
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server."
                  );
                }
              });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comnunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comnunicazione col server, impossibile caricare i dati."
            );
          }
        });
    },
    getPuntiStandard() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "MAN_STRUTTURA_DEFAULT",
          filter: "validita = 1",
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.caricamento_dati = false;
            this.items_punti_standard = new Array();
            res.data.forEach((e) => {
              this.items_punti_standard.push(Object.assign({}, e));
            });
          } else {
            this.caricamento_dati = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.caricamento_dati = false;
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comnunicazione col server, impossibile caricare i idati."
            );
          }
        });
    },
    salvaPunti() {
      const request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "settabella",
          token: localStorage.user_token,
          id_utente: localStorage.id,
          tabella: [this.punto_sel],
        },
      };

      this.caricamento_dati = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la request riceve una response conforme...
          if (res.status === 200) {
            this.caricamento_dati = false;

            // Faccio una chiamata per aggiornare le zone standard di tutte le navi
            const zona_tmp = res.data[0];
            zona_tmp.causale =
              this.punto_sel.id_tabella == -1 ? "new" : "update";

            const setzonagenerica = {
              controller: "Manutenzione",
              method: "PUT",
              richiesta: {
                action: "setzonagenerica",
                token: localStorage.user_token,
                zona: [zona_tmp],
              },
            };
            this.caricamento_dati = true;
            this.$store
              .dispatch("api", setzonagenerica)
              .then((resp) => {
                if (resp.status === 200) {
                  // Chiudo il dialog di modifica dei punti standard
                  this.dialog_modifica_punti = false;

                  // Fermo l'overlay di caricamento
                  this.caricamento_dati = false;

                  // Resetto il punto selezionato
                  this.punto_sel = new EMStandardPoint();

                  // Stampo una snackbar di conferma
                  this.$refs.SnackbarQV.print(
                    "success",
                    "Zona di Manutenzione Standard aggiunta con successo."
                  );

                  // Aggiorno la tabella dei punti standard
                  this.getPuntiStandard();
                } else {
                  this.caricamento_dati = false;
                  // Stampo una snackbar di errore
                  this.$refs.SnackbarQV.print(
                    "orange",
                    "Errore di comunicazione col server."
                  );
                }
              })
              .catch((ex) => {
                if (ex) {
                  this.caricamento_dati = false;
                  // Stampo una snackbar di conferma
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione con il server."
                  );
                }
              });
          } else {
            /* Se invece la response non è conforme blocco
             * l'overlay di caricamento e stampo un avviso. */
            this.caricamento_dati = false;

            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comnunicazione col server, impossibile caricare i idati."
            );
          }
        })
        .catch((err) => {
          // Se intercetto un errore critico stampo una snackbar di avviso.
          if (err) {
            this.caricamento_dati = false;
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comnunicazione col server, impossibile caricare i idati."
            );
          }
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>